module.exports = __webpack_public_path__ + "img/4.44239a1b.jpg";